package org.gymly.data

import io.ktor.client.HttpClient
import org.gymly.api.PortalSession
import org.gymly.api.createGymlyImageHttpClient

object PortalRepo {
    val session = PortalSession()
    private val repository = HttpPortalRepository(session)
    val api: PortalRepository = repository
    val httpClient: HttpClient get() = repository.client
    val imageHttpClient: HttpClient by lazy { createGymlyImageHttpClient(session) }
}
